import LocalizedStrings from "react-localization";

let libraryStrings = new LocalizedStrings({
    en: {
        libraryTitle: "GAME LIBRARY",
        filterTitle: "FILTER BY",
        sorts: [
            "A-Z",
            "Z-A",
            "DATE ADDED",
        ],
        studioTitle: "Studio",
        publisherTitle: "Publisher",
    },
});

export default libraryStrings;